import { createRegisterableComponent } from '@news-mono/web-common'
import { PageProps } from 'page-lifecycle-provider'
import React from 'react'
import {
    GalleryPublicationInformation,
    getPublicationInfoFromRouteResolution,
    PublicationRouteProps,
} from '../../../templates/Publication/SharedPublication.routing'
import { getPublicationPageProperties } from '../lib/publication-page-properties'
import { TheWestGallery } from './TheWestGallery'

export const TheWestGalleryRegistration = createRegisterableComponent(
    'gallery',
    (props: PublicationRouteProps, services) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)
        if (publicationInfo.publication.kind !== 'gallery') {
            throw new Error('Gallery component rendered for non-gallery')
        }

        const galleryMeta = props.meta as GalleryPublicationInformation
        return (
            <PageProps
                pageProperties={getPublicationPageProperties(
                    publicationInfo.publication,
                )}
            >
                <TheWestGallery
                    adState={services.adState}
                    gallery={publicationInfo.publication}
                    galleryMeta={galleryMeta}
                    location={services.location}
                    onEvent={services.onEvent}
                />
            </PageProps>
        )
    },
)
